// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
// Your own translation file
import en from './locale/en.ts'
import de from './locale/de.ts'
import VueI18n from 'vue-i18n'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import {storageService} from './components/StorageService'

Vue.use(VueI18n)

Vue.use(Vuetify, {
  theme: {
    primary: '#008577',
    secondary: '#00574B',
    accent: '#008577',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  },
  lang: {
    // t: (key, ...params) => i18n.t(key, params),
    locales: {en, de},
    current: navigator.language.startsWith(('de')) ? 'de' : 'en',
  }
});
Vue.config.productionTip = false

export const eventBus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: storageService,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js